import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hoikuenNaraigoto: BlogMetaData = {
  title: '保育園の習い事は平日・土日どう選ぶ？送迎負担から決める通わせ方【園長解説】',
  description:
    '保育園に通いながらの習い事は、平日・土日・オンライン・送迎サービス・園内プログラムのどれで通わせる？親の送迎回数・帰宅時間・夕食就寝・費用・継続性から、家庭ごとの判断フレームと園選びの確認点を園長が整理します。',
  thumbnailUrl: '/img/blog-hoikuen-naraigoto.webp',
  filePath: buildBlogFilePath('hoikuen-naraigoto'),
  category: BLOG_CATEGORY.NURSERY,
};
